import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllContracts from "./AllContracts";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const Contracts = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Contracts");

  document.title = "Contracts | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Contracts"
            pageTitles={[{ title: "Dashboard", link: "/dashboard" }]}
          />

          <AllContracts isViewContractors={false} isAgencyDashboard={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Contracts;
